/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React, { useState } from "react";
import classes from "./header.module.css";
import BottomHeader from "./bottomHeader/bottomHeader";
import { connect } from "react-redux";
import constants from "../../helper/constants";
import store from "../../store/store";
import AuthService from "../../auth/authService";
import { withTranslation } from "react-i18next";
import LogoutHelper from "../../helper/logoutHelper";

const Header = (props) => {
  const [showGlobalLoader, setShowGlobalLoader] = useState(false);
  const logout = () => {
    setShowGlobalLoader(true);
    LogoutHelper();
    // var tokenInfo = JSON.parse(localStorage.getItem('tokenInfo'));
    // var Cookies = document.cookie.split(';');
    // for (var i = 0; i < Cookies.length; i++) {
    //     if (window.location.protocol === 'https:' || window.location.protocol === 'HTTPS:') {
    //         document.cookie = Cookies[i].split('=')[0] + "=; path=/; domain=" + constants.envDomain + "; secure; expires=" + new Date(0).toUTCString();
    //     } else {
    //         document.cookie = Cookies[i].split('=')[0] + "=; path=/; domain=" + constants.envDomain + "; expires=" + new Date(0).toUTCString();
    //     }
    // }

    // localStorage.clear();
    // console.log('check tokenInfo', tokenInfo);
    // AuthService.signoutRedirect({ id_token_hint: tokenInfo.id_token, refresh_token: tokenInfo.refresh_token });
  };
  // var sideMenu = JSON.parse(localStorage.getItem('sideMenu'));
  var sideMenu = props.sideMenu;
  return (
    <header
      className={sideMenu ? classes.headerSideMenu : classes.header}
      style={{ borderBottom: "1px solid lightgrey" }}
    >
      {/* <div className={'topHeader'}>
                <div className={classes.innerTopHeader}>
                    <div className={classes.leftInnerTopHeader}> */}
      {/* <a href={'/#'} className={classes.linkcsb}>Cumulator IoT Portal</a>
                        <a href={'/#'} className={classes.linknorm}>|</a>
                        <a href={'/#'} className={classes.linknorm}>Digitize Things Business</a> */}
      {/* <a href={'http://digitizethings.com/'} target="blank" className={classes.linknorm}>Digitize Things</a> */}
      {/* <a href={'#'} target="blank" className={classes.linknorm}>{props.tenantData.title ? props.tenantData.title : 'Digitize Things'}</a> */}
      {/* </div>
                    <div className={classes.rightInnerTopHeader}>

                    </div>
                </div>
            </div> */}
      <BottomHeader logout={logout} />
      {showGlobalLoader && (
        <div className="init-app-global-loader">
          <div className="global-loader-icon"></div>
          <div className="global-loader-text">{props.t("LOADING_MESSAGE")}</div>
        </div>
      )}
    </header>
  );
};

const mapStateToProps = (state) => {
  return {
    tenantData: state.auth.tenantData,
    loggedInUserId: state.auth.loggedInUserId,
    sideMenu: state.auth.sideMenu,
  };
};
// Set data to redux store
const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation("translations")(Header));
// export default connect(mapStateToProps)()
